import { createSelector } from 'reselect'
import * as File from './file'
import * as Datatype from './datatype'
import { validate as validateValues } from '../lib/validate'
import titleize from '../titleize'

export const getValidator = createSelector([ File.getAPI, Datatype.all ], (FileAPI, datatypes) => {
  datatypes = new Set(datatypes)
  const filetypes = FileAPI.getFileTypeSchemas()
  return (value, schema) => {
    return Object.assign(
      validateDataTypes(value, schema, FileAPI, datatypes),
      validateFileTypes(value, schema, FileAPI, filetypes),
      validateValues(value, schema)
    )
  }
})

/**
 * Ensure file values match expected data types
 */

function validateDataTypes (value, schema, FileAPI, datatypes) {
  const properties = findFileProperties(value, schema)
  if (!Object.keys(properties)) return
  return [...Object.entries(properties)].reduce((errors, [ key, { property, value } ]) => {
    if (!property.datatype) return errors
    // check for match
    if (!FileAPI.isDatatype({ path: value, datatype: property.datatype })) {
      const datatype = FileAPI.getDatatype(value)
      const actual = titleizeDatatype(datatype) || '(unknown)'
      const expected = titleizeDatatype(property.datatype) || '(unknown)'
      return Object.assign(errors, {
        [key]: `Wrong Datatype: ${actual}. Expected: ${expected}`
      })
    }

    return errors
  }, {})
}

function validateFileTypes (value, schema, FileAPI, filetypes) {
  if (schema.name === 'Input_Data') {
    const filename = value[`${schema.id}/filename`]
    let error
    const datatype = FileAPI.getDatatype(filename)
    if (!datatype) {
      error = `Unknown Datatype`
    }
    if (!FileAPI.getFiletype(filename)) {
      error = `Unknown Filetype`
    }

    if (!FileAPI.getIsValidExtension(filename)) {
      error = `Invalid Extension${datatype ? ` for ${titleize(datatype)}` : ''}`
    }

    if (!error) return
    return {
      [`${schema.id}/filename`]: error
    }
  }
  if (schema.name === 'Import_Data_File') {
    const format = value[`${schema.id}/Input_Data_File/format`]
    const specifySize = value[`${schema.id}/Input_Data_File/specify_voxel_size`]
    const filetype = filetypes.find(f => f.id === format)
    if (!format.providesVoxelSize && specifySize === 'false') {
      return {
        [`${schema.id}/Input_Data_File/specify_voxel_size`]: `Required for ${filetype.longName}`
      }
    }
  }
}

/**
 * Collect all active file type properties for a schema, along with
 * associated values.
 */

function findFileProperties (value, schema, results = {}) {
  let properties = schema.properties
  if (schema.isList) {
    const key = schema.path.join('/')
    const listValue = value[key] != null ? String(value[key]) : ''
    const matchingSchema = schema.properties.find(schema => schema.condition === listValue)
    properties = matchingSchema ? [matchingSchema] : []
  }
  properties.forEach(property => {
    if (property.properties) findFileProperties(value, property, results)
    if (property.type !== 'file') return
    const key = property.path.join('/')
    results[key] = {
      property,
      value: value[key]
    }
  })
  return results
}

function titleizeDatatype (datatype = '') {
  return datatype.replace(/_/g, ' ').replace(' Data', '')
}



// WEBPACK FOOTER //
// ../webmango-core/selectors/validate.js